import { post,get,postJson } from '../axios'

//解密接口
export const decrypt = p => get(`/members-api/public/yunzhou/content/decrypt`, p);

//获取验证码
export const getCheckCode = p => post(`/members-api/public/sendSmsVerifyCode`, p);

//更新云舟账号绑定手机号信息
export const updatePlatformAccountMobile = p => post(`/members-api/sysSellerPhoneSetting/updateYunzhouUserMobile`, p);

//修改云舟账号密码
export const changeUserPwd = p => postJson(`/members-api/home/yunzhou-user-password`, p);

//退出登录
export const logOut = p => get(`/members-api/loginController/loginTimeout`, p);